module.exports = __webpack_public_path__ + "static/dashboard-img-defc721328aed6be793e4c4ed21ec3d1.png";